export default __webpack_public_path__ + "static/media/logout-icon.68ace3b1.svg";